import {TableCell, TableRow} from "@material-ui/core";
import React from "react";
import { VALUES } from "../constants/AuditTaskType";
import TextInput from "components/TextInput";
import getObjectValue from "libs/getObjectValue";
import WorkableIconDeleteButton from "components/button/WorkableIconDeleteButton";


function AuditTaskUserRow({
    id,
    index,
    formikProps,
    taskId,
    deleteUser,
    type,
    editable
}) {

    const internal = VALUES.INTERNAL === type;
    const formId = `${id}.${index}`;
    const user = getObjectValue(formId, formikProps.values, {});

    return (
        <TableRow>
            <TableCell>{internal ? user.firstName :
                <TextInput
                    id={`${formId}.firstName`}
                    formikProps={formikProps}
                    disabled={!editable}
                    limit={50}
                    showErrorImmediately
                />}
            </TableCell>
            <TableCell>{internal ? user.lastName :
                <TextInput
                    id={`${formId}.lastName`}
                    formikProps={formikProps}
                    disabled={!editable}
                    limit={50}
                    showErrorImmediately
                />}
            </TableCell>
            <TableCell>{internal ? user.email :
                <TextInput
                    id={`${formId}.email`}
                    formikProps={formikProps}
                    disabled={!editable}
                    limit={250}
                    showErrorImmediately
                />}
            </TableCell>
            <TableCell>
                {editable && <WorkableIconDeleteButton onClick={() => deleteUser(index)} />}
            </TableCell>
        </TableRow>
    )
}

export default AuditTaskUserRow;